import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { initLenis, destroyLenis, scrollToTop } from "@/lib/lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Percorsi from "@/pages/Percorsi";
import Diplomi from "@/pages/Diplomi";
import Lauree from "@/pages/Lauree";
import Formazione from "@/pages/Formazione";
import Certificazioni from "@/pages/Certificazioni";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  return null;
};

const Layout = () => {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/percorsi" element={<Percorsi />} />
          <Route path="/diplomi" element={<Diplomi />} />
          <Route path="/lauree" element={<Lauree />} />
          <Route path="/formazione-professionale" element={<Formazione />} />
          <Route path="/certificazioni" element={<Certificazioni />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-left" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
